export default class MobileMenu {
  constructor(element, options = {}) {
    this.settings = {
      ...this.options,
      ...options,
    }

    this.init(element);
  }

  get options() {
    return {
      speed: 300,
    }
  }

  init(element) {
    this.menu = jQuery(element);
    this.trigger = jQuery('[data-trigger="mobile-menu"]');
    this.close = jQuery('[data-close="mobile-menu"]')
    this.base = this.menu.children().last();

    this.searchTrigger = jQuery('[data-trigger="search-bar"]');
    this.isSearchBarOpen = false;

    const { menu, settings } = this;

    // Add transitions
    this.transition(settings.speed);

    // Create header item to prepend nested lists
    const header = jQuery('<li>').addClass('header');
    jQuery('> ul > li > ul', menu).prepend(header);

    // Create back button and prepend to header
    const back = jQuery('<a>').prop('href', '#').addClass('back');
    jQuery('.header').prepend(back);

    jQuery('> ul > li > ul', menu).each((index, el) => {
      const label = 'Main Menu';
      const title = jQuery('<div>').addClass('nav-item-title').text(label);
      jQuery('> .header', el).append(title);
    })

    // Add event listeners
    this.addListeners();
  }

  addListeners() {
    const { menu } = this;

    // Open side menu when trigger element is clicked
    jQuery(this.trigger).on('click', this.openSideMenu);
    jQuery(this.close).on('click', this.closeSideMenu);

    // Show search bar when search button is clicked
    jQuery(this.searchTrigger).on('click', this.toggleSearchBar);

    jQuery('.navbar-nav a').on('click', e => {
      const link = jQuery(e.currentTarget)

      // Only prevent default when we click an empty link or a next/back arrow
      if (
        link.attr("href").includes("#") ||
        link.hasClass("back") ||
        link.hasClass("next")
      ) {
        e.preventDefault();
      }

      if (link.hasClass('next')) {
        // Remove current active link
        menu.find('.active').removeClass('active');

        // Set the new active link
        link
          .next()
          .show()
          .addClass('active')

        // Move
        this.move(1);
      } else if (link.hasClass('back')) {
        this.move(-1, () => {
          menu.find('.active').removeClass('active');
          link.parent().parent().hide();
        })
      } else {
        this.closeSideMenu();
      }
    })
  }

  transition(speed = 400) {
    const { menu, base } = this;

    menu.css('transition-duration', `${speed}ms`);
    base.css('transition-duration', `${speed}ms`);
  }

  move(depth = 0, callback = () => {}) {
    if (depth === 0) return;

    const { settings, base } = this;

    // Get the current left position
    const left = Math.round(parseInt(base.get(0).style.left)) || 0;

    // Set the new left position
    base.css('left', `${left - depth * 100}%`);

    // Callback after animation
    setTimeout(callback, settings.speed);
  }

  openSideMenu() {
    document.body.classList.add('side-menu-active');
  }

  closeSideMenu() {
    document.body.classList.remove('side-menu-active');
  }

  toggleSearchBar() {
    this.isSearchBarOpen = !this.isSearchBarOpen;

    jQuery('.mobile-search-bar')
      .css('display', this.isSearchBarOpen ? 'block' : 'none');
  }
}

/**
 * jQuery method to initialize mobileMenu
 */
($ => {
  $.fn.initMobileMenu = function(options) {
    return new MobileMenu(this, options);
  }
})(jQuery);
